import { render, staticRenderFns } from "./realFooter.vue?vue&type=template&id=87712a66&scoped=true"
import script from "./realFooter.vue?vue&type=script&lang=js"
export * from "./realFooter.vue?vue&type=script&lang=js"
import style0 from "./realFooter.vue?vue&type=style&index=0&id=87712a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87712a66",
  null
  
)

export default component.exports